module.exports = __webpack_public_path__ + "static/img/MC.ae3b9334.svg";